import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import DollarOutlined from '@ant-design/icons/DollarOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import FileDoneOutlined from '@ant-design/icons/FileDoneOutlined';
import DeploymentUnitOutlined from '@ant-design/icons/DeploymentUnitOutlined';
import CloudUploadOutlined from '@ant-design/icons/CloudUploadOutlined';
import SendOutlined from '@ant-design/icons/SendOutlined';

function join(base, path) {
  return `${String(base || '').replace(/\/$/, '')}/${String(path || '').replace(/^\//, '')}`;
}

function mkItem(id, title, url, Icon) {
  return { id, title, type: 'item', url, icon: Icon, breadcrumbs: false };
}

function mkCollapse(id, title, Icon, children, url) {
  return { id, title, type: 'collapse', icon: Icon, children, url, breadcrumbs: false };
}

export function buildMenu(prefix = '', { admin = false, pages = [], pageLimit = 10 } = {}) {
  const items = [];

  if (admin) {
    items.push(
      mkItem('dashboard', 'Dashboard', join(prefix, 'dashboard'), DashboardOutlined),


      mkCollapse(
        'subscriptions',
        'Subscriptions',
        DollarOutlined,
        [
          mkItem('manage-subscriptions', 'Manage Subscription', join(prefix, 'subscriptions/manage'), DeploymentUnitOutlined),
        ],
        join(prefix, 'subscriptions/manage')
      ),

      mkItem('facebook-users', 'Facebook Users', join(prefix, 'facebook-users'), TeamOutlined),


      mkCollapse(
        'invoices',
        'Invoices',
        FileTextOutlined,
        [
          mkItem(
            'subscription-invoices',
            'Subscription Invoices',
            join(prefix, 'invoices/subscription-invoices'),
            FileDoneOutlined
          ),
        ],
        join(prefix, 'invoices/subscription-invoices')
      ),

      mkItem('bulk-jobs', 'Bulk Messenger Jobs', join(prefix, 'bulk-jobs'), SendOutlined)
    );
  } else {
    // Optional “grid” entry
    // items.push(mkItem('pages-home', 'Pages', join(prefix, 'dashboard'), DashboardOutlined));

    // Emit each page as a TOP-LEVEL item (no collapse)
    if (Array.isArray(pages) && pages.length) {
      const limited = pages.slice(0, pageLimit);
      for (const p of limited) {
        const id = String(p.page_id || p.id);
        const name = String(p.name || 'Untitled');
        const pic = p.picture_url || p.cover?.source || p.picture?.data?.url || '';

        items.push({
          id: `page-${id}`,
          type: 'item',
          url: join(prefix, `pages/${id}`),
          // these two fields are what NavItem will use:
          rawTitle: name,  // render literal name instead of i18n key
          img: pic,        // render picture_url as the icon
          breadcrumbs: false,
          search: name.toLowerCase()
        });
      }
      if (pages.length > limited.length) {
        items.push(mkItem('pages-more', 'See all…', join(prefix, 'dashboard')));
      }
    }
  }

  return { items: [{ id: 'group-main', type: 'group', children: items }] };
}

export const buildUserMenu = (prefix = '', pages, pageLimit) =>
  buildMenu(prefix, { admin: false, pages, pageLimit });

export const buildAdminMenu = (prefix = '/admin') =>
  buildMenu(prefix, { admin: true });
